// extracted by mini-css-extract-plugin
export var dots = "postMerchantsWidget-module--dots--b6c6e";
export var slider = "postMerchantsWidget-module--slider--be8ff";